import React, { useEffect } from "react";
import contactUsImg from "../assets/WebImage/contactus.jpg";
import { Link } from "react-router-dom";

function ContactUs() {
  const today = new Date();

  useEffect(() => {
    document.title = "Free Credit - Contact Us";
  }, []);

  return (
    <>
      <div className="card m-2">
        <div style={{ textAlign: "justify" }}>
          {" "}
          <div>
            <img
              style={{ maxWidth: "100%", height: "auto", display: "block" }}
              loading="lazy"
              src={contactUsImg}
              alt="Contact Us-Jom Free Credit Malaysia - freekredit freecredit linkfreekredit linkfreecredit megafreecredit
      megafreekredit"
            />
          </div>
          <div className="p-3">
            <h1 style={{ textAlign: "left" }}>
              Contact Us - JomFreeCredit.online
            </h1>
            <strong>Last Updated: </strong>
            {today.toLocaleDateString("en-MY", {
              day: "numeric",
              month: "long",
              year: "numeric",
            })}
            <br />
            <br />

            <p>
              Thank you for visiting JomFreeCredit.online. We value transparency
              and open communication with our users.
            </p>
            <p>
              If you have any questions regarding our content, editorial
              policies, free credit listings, or online casino information, feel
              free to reach out to us.
            </p>

            <hr />

            <h2>Get in Touch</h2>
            <p>
              Our team is available to assist with general inquiries, feedback,
              and clarification requests related to the information published on
              JomFreeCredit.online.
            </p>

            <ul>
              <li>
                <strong>Email:</strong> support@jomfreecredit.online
              </li>
              <li>
                <strong>Response Time:</strong> We aim to respond within 24–48
                hours
              </li>
            </ul>

            <p>
              Please note that JomFreeCredit.online operates as an informational
              platform. We do not manage user accounts, process transactions, or
              provide direct gambling services.
            </p>

            <hr />

            <h2>Types of Inquiries</h2>
            <p>You may contact us for the following matters:</p>
            <ul>
              <li>Questions about free credit or no deposit promotions</li>
              <li>Clarification on casino review content</li>
              <li>Reporting inaccurate or outdated information</li>
              <li>Feedback or suggestions for improvement</li>
              <li>General website inquiries</li>
            </ul>

            <hr />

            <h2>Important Notice</h2>
            <p>
              JomFreeCredit.online is not affiliated with or responsible for the
              operations of third-party online casino platforms listed on our
              website.
            </p>
            <p>
              For account-related issues such as deposits, withdrawals, or login
              problems, users must contact the respective casino platform
              directly.
            </p>

            <hr />

            <h2>Responsible Communication</h2>
            <p>
              We encourage all users to communicate respectfully and provide
              clear details when submitting inquiries to help us respond more
              efficiently.
            </p>

            <hr />

            <h2>Explore More</h2>
            <p>
              Learn more about how JomFreeCredit.online operates by visiting our
              <Link to="/editorial" style={{ textDecoration: "none" }}>
                <span> </span>Editorial Policy
              </Link>
              ,
              <Link to="/privacypolicy" style={{ textDecoration: "none" }}>
                <span> </span>Privacy Policy
              </Link>
              ,
              <Link to="/responsiblegaming" style={{ textDecoration: "none" }}>
                <span> </span>Responsible Gaming
              </Link>
              <span> </span>pages.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default ContactUs;
